export enum ContactType {
  billing = 'billing',
  custom = 'custom',
}

export enum ContactTypeLabel {
  billing = 'Billing',
  custom = 'Custom',
}
